<template>
  <v-menu min-width="280" bottom left>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on">
        <v-icon small>
          mdi-dots-vertical
        </v-icon>
      </v-btn>
    </template>

    <v-list dense>
      <v-list-item v-if="!checkUserRole(['ROLE_SUPPORT'])" @click="$emit('showUpdateCustomerModal', item)">
        <v-list-item-title>
          <v-row align="center" no-gutters>
            <v-col cols="2">
              <v-icon color="grey lighten-1" small>
                mdi-pencil-outline
              </v-icon>
            </v-col>
            <v-col cols="10">
              <span class="body-2">
                {{ $t('customer.label.edit') }}
              </span>
            </v-col>
          </v-row>
        </v-list-item-title>
      </v-list-item>

      <v-list-item :to="`/real-estate-branches/${item.id}`">
        <v-list-item-title>
          <v-row align="center" no-gutters>
            <v-col cols="2">
              <v-icon color="grey lighten-1" small> mdi-home-export-outline </v-icon>
            </v-col>
            <v-col cols="10">
              <span class="body-2">
                {{ $t('customer.label.showBranches') }}
              </span>
            </v-col>
          </v-row>
        </v-list-item-title>
      </v-list-item>

      <v-list-item v-if="!checkUserRole(['ROLE_SUPPORT'])" @click="$emit('handleAsaasAction', item)">
        <v-list-item-title>
          <v-row align="center" no-gutters>
            <v-col cols="2">
              <v-icon color="grey lighten-1" small>
                {{
                  !item.asaas_customer_id
                    ? `mdi-link-variant`
                    : `mdi-link-variant-off`
                }}
              </v-icon>
            </v-col>
            <v-col cols="10">
              <span class="body-2">
                {{
                  (!item.asaas_customer_id
                    ? 'Vincular'
                    : 'Desvincular') + ' Asaas'
                }}
              </span>
            </v-col>
          </v-row>
        </v-list-item-title>
      </v-list-item>

      <!-- <v-list-item v-if="!checkUserRole(['ROLE_SUPPORT'])" @click="$emit('openLinkServiceProviderModal', item)">
        <v-list-item-title>
          <v-row align="center" no-gutters>
            <v-col cols="2">
              <v-icon color="grey lighten-1" small>
                mdi-account-file-text-outline
              </v-icon>
            </v-col>
            <v-col cols="10">
              <span class="body-2">
                {{ $t('customer.label.linkServiceProvider') }}
              </span>
            </v-col>
          </v-row>
        </v-list-item-title>
      </v-list-item> -->

      <v-list-item v-if="!checkUserRole(['ROLE_SUPPORT'])" @click="$emit('showLinkVendorsModal', item.id, item.vendors)">
        <v-list-item-title>
          <v-row align="center" no-gutters>
            <v-col cols="2">
              <v-icon color="grey lighten-1" small>
                mdi-account-hard-hat-outline
              </v-icon>
            </v-col>
            <v-col cols="10">
              <span class="body-2">
                {{ $t('customer.label.linkVendors') }}
              </span>
            </v-col>
          </v-row>
        </v-list-item-title>
      </v-list-item>

      <v-list-item v-if="!checkUserRole(['ROLE_SUPPORT'])" @click="$emit('addNewCustomContract', item.id)">
        <v-list-item-title>
          <v-row align="center" no-gutters>
            <v-col cols="2">
              <v-icon color="grey lighten-1" small> mdi-plus </v-icon>
            </v-col>
            <v-col cols="10">
              <span class="body-2">
                {{ $t('customer.label.newContract') }}
              </span>
            </v-col>
          </v-row>
        </v-list-item-title>
      </v-list-item>

      <v-list-item :to="`/real-estate-contracts/${item.id}`">
        <v-list-item-title>
          <v-row align="center" no-gutters>
            <v-col cols="2">
              <v-icon color="grey lighten-1" small>
                mdi-text-box-outline
              </v-icon>
            </v-col>
            <v-col cols="10">
              <span class="body-2">
                {{ $t('customer.label.visualizeContracts') }}
              </span>
            </v-col>
          </v-row>
        </v-list-item-title>
      </v-list-item>

      <v-list-item @click="$emit('showAddBalanceModal', item.id)">
        <v-list-item-title>
          <v-row align="center" no-gutters>
            <v-col cols="2">
              <v-icon color="grey lighten-1" small>
                mdi-account-cash-outline
              </v-icon>
            </v-col>
            <v-col cols="10">
              <span class="body-2">
                {{ $t('movement.label.changeBalance') }}
              </span>
            </v-col>
          </v-row>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { checkUserRole } from '@/util/helpers'

export default {
  name: 'ListActionsMenu',

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  methods: {
    checkUserRole,
  }
}
</script>
